/*
 * Copyright (c) Nexign, JSC, 2019-2025.
 */
/**
 *
 * @author Yakov Gushchin
 * @author Evgenij Tyan
 * @author Anton Panasenko
 * @author Aleksandr Perkhunov
 * @author Dmitriy Kvon
 * @author Nikolay Sviridov
 * @version 1.36.0
 * @since 1.0.0
 */
import { IPageSubscriberMobileTranslation } from '../../types';

const initTranslationPageSubscriberMobile: IPageSubscriberMobileTranslation = {
    buttonMode: {
        disableAllExceptInArray: {},
    },
    extFilter: {
        ACCESS: '',
        ACCOUNT: '',
        AND: '',
        apply: '',
        atribute: '',
        close: '',
        CONTRACT_NUMBER: '',
        createFilter: '',
        delete: '',
        DC_RULE: '',
        EQ: '',
        LABEL: '',
        NAME: '',
        nameFilter: '',
        NE: '',
        NUMBER_TYPE: '',
        NUMBER: '',
        OR: '',
        PERSONAL_ACC: '',
        POST: '',
        save: '',
        saveAs: '',
        savedFilters: '',
        STARTS_WITH: '',
        STATUS: '',
        TARIFF: '',
        title: '',
        value: '',
    },
    infoTableUpdate: '',
    table: {
        accessName: {
            header: '',
        },
        account: {
            header: '',
        },
        accountName: {
            header: '',
        },
        assistantCampaignsCount: {
            header: '',
        },
        balance: {
            header: '',
        },
        cityNumber: {
            header: '',
        },
        contractNumber: {
            header: '',
        },
        coordinatorCampaignsCount: {
            header: '',
        },
        dcRules: {
            header: '',
        },
        icc: {
            header: '',
        },
        inn: {
            header: '',
        },
        kpp: {
            header: '',
        },
        labels: {
            header: '',
        },
        loyaltyStatus: {
            header: '',
        },
        msisdn: {
            header: '',
        },
        name: {
            header: '',
        },
        numberType: {
            header: '',
        },
        persDataLockDate: {
            header: '',
        },
        persDataStatusName: {
            header: '',
        },
        position: {
            header: '',
        },
        ratePlan: {
            header: '',
        },
        status: {
            header: '',
        },
        subdivisionKpp: {
            header: '',
        },
        subdivisionName: {
            header: '',
        },
        zone: {
            header: '',
        },
        currCountryName: {
            header: '',
        },
        eventTimeChangeCountry: {
            header: '',
        },
    },
    tableFilter: {
        msisdn: {
            filtersMaxSize: '',
            filtersMaxSizeSymbol: '',
        },
    },
    tableFooter: {
        basketTitle: '',
        confirmButton: '',
        confirmButtonTooltip: '',
        cancel: '',
        linkMessage: {
            title: '',
            tooltip: '',
        },
    },
    title: {
        dropFilters: '',
        exportBtn: '',
        filterSetting: '',
        header: '',
        fastActionRadioButton: '',
        fastInquiryCreateTitle: '',
        fastInquiryCreateSubstitle: '',
        importSetting: {
            titleBtn: '',
            importBtn: '',
            deleteBtn: '',
            disabledByLowerLimitBtn: '',
            disabledByUpperLimitBtn: '',
            declinedSubs: '',
        },
        importSettingAndLimits: {
            titleBtn: '',
            importBtn: '',
            deleteBtn: '',
            disabledByLowerLimitBtn: '',
            disabledByUpperLimitBtn: '',
            declinedSubs: '',
            wizardMultiSearch: '',
        },
        importSettingOld: '',
        tableSetting: {
            applyBtn: '',
            closeBtn: '',
            footnote: '',
            subTitle: '',
            title: '',
            titleBtn: '',
        },
        wizardMultiSearch: '',
    },
    roamSubscribersPlate: {
        switcherText: '',
        infoText: '',
        connectButton: '',
        connetButtonTooltips: {
            noSubsSelected: '',
            tooManySelected: '',
        },
        closeButtonTooltip: '',
    },
    changeService: {
        maxCount: '',
        maxZone: '',
        noZone: '',
    },
    changeTariff: {
        maxCount: '',
        maxZone: '',
        noZone: '',
    },
};

export default initTranslationPageSubscriberMobile;
